(function ($) {

    $('#acf-field_612bdc24eba44-field_6256c8437ca67').attr('pattern', '^[0-9]{2} [0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}$');

    setTimeout(function () {
        var crm_path = $('#theme_dir').val();
        // console.log(crm_path);
        if ($('.checkbox-icons').length > 0) {
            $('.checkbox-icons ul input').each(function () {
                var icon = $(this).val(), th = $(this);
                $(this).closest('label').html($(this).closest('label').html().replace($(this).closest('label').text(), '<img src="' + crm_path + '/img/icons/' + icon + '.png" />'));
                // $(this).closest('label').append('<img src="'+crm_path+'/img/icons/'+icon+'.png" />');
            })
        }
    }, 600);

    $('.open-edit-task-form').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.window-editor').find('.comments-list .single-comment, .form-add-new-task').hide();
        $(this).closest('.single-comment').show();
        $(this).closest('.single-comment').find('.meta, .comment-content').hide();
        $(this).closest('.single-comment').find('.edit-task').show();
        $(this).remove();
    });
    $('.select-all-clients').on('click', function () {
        $(this).closest('table').find('td.col-checkbox input').prop('checked', $(this).prop('checked'));
    });
    $('.all-pages-selector').on('click', function(e){
        e.preventDefault();
        if($(this).hasClass('unselected')){
            $(this).removeClass('unselected');
            $(this).addClass('selected');
            $(this).html($(this).attr('data-selected'));
            $('#all-pages').prop('checked', true);
        }
        else{
            $(this).removeClass('selected');
            $(this).addClass('unselected');
            $(this).html($(this).attr('data-unselected'));
            $('#all-pages').prop('checked', false);
        }
    })
    $('.add-client-note').on('click', function (e) {
        e.preventDefault();
        $(this).next('form').slideToggle(300);
    });
    $('.mass-actions-toggle').on('click', function () {
        var clicked = false;
        $('.mass-actions-toggle').each(function () {
            if ($(this).prop('checked') == true) {
                clicked = true;
            }
        });
        if (clicked) {
            $('.mass-actions').slideDown(300);
        } else {
            $('.mass-actions').slideUp(300);
        }
    });
    $(document).ready(function () {
        if ($('[data-key="field_620da08052b60"]').length > 0) {
            setInterval(function () {
                $('[data-key="field_620da08052b60"] .file-info a').each(function () {
                    $(this).closest('.file-info').find('img').remove();
                    var url = $(this).attr('href'), ext, td = $('body').attr('data-template-dir'), icon;
                    ext = url.substr(url.length - 4);
                    switch (ext) {
                        case '.jpg':
                        case 'jpeg':
                        case '.gif':
                        case '.png':
                            icon = 'photo';
                            break;
                        case '.pdf':
                            icon = 'pdf';
                            break;
                        case '.doc':
                        case 'docx':
                            icon = 'doc';
                            break;
                        case '.xls':
                        case 'xlsx':
                            icon = 'xls';
                            break;
                        case '.ppt':
                        case 'pptx':
                            icon = 'ppt';
                            break;
                        default:
                            icon = 'file';
                            break;

                    }
                    $(this).closest('.file-info').prepend('<img src="' + td + '/img/icons/' + icon + '.svg" />');
                })
            }, 1000)
        }
        $('#add-emails-to-newsletter').on('submit', function(e){
            e.preventDefault();
            var search_args = false;
            var clients = '';
            $('[data-client-id]:checked').each(function(){
                clients = clients + $(this).val() + '||';
            });
            if($('#all-pages').prop('checked') == true){
                search_args = $('#current-search-args').val();
            }
            $.ajax({
                url: ajax_ajax_obj.ajaxurl,
                method: 'post',
                data: {
                    'action': 'add_emails_to_newsletter',
                    'search': search_args,
                    'clients': clients,
                    'template': $('#send-email [name="template"]').val(),
                    'subject': $('#send-email [name="subject"]').val(),
                    'nonce': ajax_ajax_obj.nonce
                },
                beforeSend: function(){
                    $('#added-to-newsletter').remove();
                },
                success: function (data) {
                    console.log(data);
                    $('<div id="added-to-newsletter">Dodano do kolejki</div>').insertAfter('#send-email [type="submit"]');
                    $('#send-email [type="submit"]').remove();
                },
                error: function (errorThrown) {
                    console.log(errorThrown);
                }
            });
        })
        $('#add-phones-to-sms-sender').on('submit', function(e){
            e.preventDefault();
            var search_args = false;
            var clients = '';
            $('[data-client-id]:checked').each(function(){
                clients = clients + $(this).val() + '||';
            });
            if($('#all-pages').prop('checked') == true){
                search_args = $('#current-search-args').val();
            }
            $.ajax({
                url: ajax_ajax_obj.ajaxurl,
                method: 'post',
                data: {
                    'action': 'add_phones_to_sms_sender',
                    'search': search_args,
                    'clients': clients,
                    'body': $('#send-sms [name="body"]').val(),
                    'nonce': ajax_ajax_obj.nonce
                },
                beforeSend: function(){
                    $('#added-to-newsletter').remove();
                    $('#send-sms [type="submit"]').hide();
                },
                success: function (data) {
                    // console.log(data);
                    $('<div id="added-to-newsletter">Dodano do kolejki</div>').insertAfter('#send-sms [type="submit"]');
                    // $('#send-sms [type="submit"]').remove();
                },
                error: function (errorThrown) {
                    console.log(errorThrown);
                }
            });
        })
    })

    $(document).ready(function() {
        $('#add-phones-to-sms-sender textarea').on('keyup', function() {
            let charCount = $(this).val().length;
            let smsCount = Math.ceil(charCount / 160) || 1;
            $('#add-phones-to-sms-sender .sms-total').text('Łączna liczba znaków: ' + charCount + ' ('+smsCount+' SMS)');
        });
    });
})(jQuery);